// Shared navbar tour steps configuration
export const getNavbarTourSteps = (userInfo = null) => {
  const steps = [];

  // Step 1: Logo - dynamic message based on user role
  const isNonAdmin = userInfo?.role !== 'admin';
  const logoMessage = 'Welcome to Nano Client Portal!' +
    (isNonAdmin ? ' This is your company logo and name indicating the data is for your version of Nano.' : '');

  steps.push({
    element: '[data-intro="navbar-logo"]',
    intro: logoMessage,
    position: 'bottom'
  });

  // Step 2: Navigation
  steps.push({
    element: '[data-intro="navbar-navigation"]',
    intro: 'Use these navigation tabs to see different data of Nano usage like trends and diet requests.',
    position: 'bottom'
  });

  // Step 3: User Menu
  steps.push({
    element: '[data-intro="navbar-user"]',
    intro: 'This user menu shows your information and logout option.',
    position: 'bottom-left'
  });

  // Step 4: Admin Role Badge (conditionally added based on DOM presence)
  const adminBadge = document.querySelector('[data-intro="navbar-admin-badge"]');
  if (adminBadge) {
    steps.push({
      element: '[data-intro="navbar-admin-badge"]',
      intro: 'This badge indicates you have administrator privileges with access to all features and data.',
      position: 'bottom'
    });
  }

  // Step 5: Theme Toggle
  steps.push({
    element: '[data-intro="navbar-theme"]',
    intro: 'Switch between light and dark themes to customize your viewing experience.',
    position: 'bottom-left'
  });

  return steps;
};
